export enum QUERY_PARAMS_ACTION_TYPES {
  preserve = 'preserve', // preserve old params and add new ones
  merge = 'merge', // add new params and update existing ones
  overwrite = 'overwrite', // overwrite all params with new param object
  update = 'update', // keeps adding params even if same param is present , as multiselect is available for plp
  remove = 'remove', // removes particular queryparam
}
